import * as React from 'react';
import { Container } from 'reactstrap';
import { useAuth } from '../Services/AuthContext';
import useFetch from '../Services/useFetch';
import './EnvironmentBanner.css';

const EnvironmentBanner = () => {
    const [auth] = useAuth();
    const isAdmin = auth?.role === 'Admin';
    const [data] = useFetch(isAdmin ? '/api/environment' : null);

    // Only staging is flagged; live and development show nothing.
    if (!isAdmin || String(data?.name).toLowerCase() !== 'staging') return null;

    return (
        <Container>
            <div className="env-banner" role="status">STAGING ENVIRONMENT - changes here do not affect live</div>
        </Container>
    );
};

export default EnvironmentBanner;
